import AxiosLib from "axios";

const axios = AxiosLib.create();

export default axios;
